import SvgIcon from "./Icon";
import update from "immutability-helper";
import * as _ from "lodash";
import * as React from "react";
import { Button as BootstrapButton, NavItem as BootstrapNavItem, Overlay, OverlayTrigger, Popover, } from "react-bootstrap";
/**
 * Button with a tooltip
 *
 */
export class Button extends React.PureComponent {
    render() {
        const { tooltip } = this.props;
        const relayProps = { ...this.props };
        delete relayProps.tooltip;
        delete relayProps.placement;
        if (tooltip === undefined || typeof this.props.tooltip === "string") {
            return (React.createElement(BootstrapButton, { ...relayProps, title: this.props.tooltip }, this.props.children));
        }
        else {
            const tooltipCtrl = (React.createElement(Popover, { id: this.props.id }, this.props.tooltip));
            return (React.createElement(OverlayTrigger, { overlay: tooltipCtrl, placement: this.props.placement || "bottom", delayShow: 300, delayHide: 150 },
                React.createElement(BootstrapButton, { ...relayProps }, this.props.children)));
        }
    }
}
const iconPropNames = new Set([
    "spin",
    "pulse",
    "stroke",
    "hollow",
    "border",
    "inverse",
    "flip",
    "rotate",
    "rotateId",
    "vertical",
    "set",
]);
export class IconButton extends React.Component {
    render() {
        const buttonProps = {};
        const iconProps = {};
        Object.keys(this.props).forEach((propKey) => {
            if (["tooltip", "placement", "icon"].includes(propKey)) {
                return;
            }
            if (iconPropNames.has(propKey)) {
                iconProps[propKey] = this.props[propKey];
            }
            else {
                buttonProps[propKey] = this.props[propKey];
            }
        });
        if (buttonProps["className"] !== undefined) {
            buttonProps["className"] += " icon-button";
        }
        else {
            buttonProps["className"] = "icon-button";
        }
        if (React.Children.count(this.props.children) > 0) {
            buttonProps["className"] += " has-children";
        }
        if (this.props.vertical) {
            buttonProps["className"] += " icon-button-vertical";
        }
        else {
            buttonProps["className"] += " icon-button-horizontal";
        }
        if (this.props.tooltip === undefined) {
            return (React.createElement(BootstrapButton, { ...buttonProps },
                React.createElement(SvgIcon, { name: this.props.icon, ...iconProps }),
                this.props.children));
        }
        else if (typeof this.props.tooltip === "string") {
            return (React.createElement(BootstrapButton, { ...buttonProps, title: this.props.tooltip },
                React.createElement(SvgIcon, { name: this.props.icon, ...iconProps }),
                this.props.children));
        }
        else {
            const tooltip = (React.createElement(Popover, { id: this.props.id }, this.props.tooltip));
            return (React.createElement(OverlayTrigger, { overlay: tooltip, placement: this.props.placement || "bottom", delayShow: 300, delayHide: 150 },
                React.createElement(BootstrapButton, { ...buttonProps },
                    React.createElement(SvgIcon, { name: this.props.icon, ...iconProps }),
                    this.props.children)));
        }
    }
}
export class ToggleButton extends React.Component {
    render() {
        const { state } = this.props;
        const relayProps = { ...this.props };
        [
            "buttonType",
            "tooltip",
            "offTooltip",
            "placement",
            "onIcon",
            "offIcon",
            "state",
        ].forEach((prop) => {
            delete relayProps[prop];
        });
        const bType = this.props.buttonType || "icon";
        const icon = state ? this.props.onIcon : this.props.offIcon;
        const tooltipText = state ? this.props.tooltip : this.props.offTooltip;
        if (typeof tooltipText === "string") {
            return (React.createElement(BootstrapButton, { ...relayProps, title: tooltipText },
                ["icon", "both"].indexOf(bType) !== -1 ? (React.createElement(SvgIcon, { name: icon })) : null,
                ["text", "both"].indexOf(bType) !== -1 ? (React.createElement("p", { className: "button-text" }, tooltipText)) : null,
                this.props.children));
        }
        else {
            const tooltip = React.createElement(Popover, { id: this.props.id }, tooltipText);
            return (React.createElement(OverlayTrigger, { overlay: tooltip, placement: this.props.placement || "bottom", delayShow: 300, delayHide: 150 },
                React.createElement(BootstrapButton, { ...relayProps },
                    ["icon", "both"].indexOf(bType) !== -1 ? (React.createElement(SvgIcon, { name: icon })) : null,
                    ["text", "both"].indexOf(bType) !== -1 ? (React.createElement("p", { className: "button-text" }, tooltipText)) : null,
                    this.props.children)));
        }
    }
}
export class NavItem extends React.Component {
    render() {
        const relayProps = { ...this.props };
        delete relayProps.tooltip;
        delete relayProps.placement;
        if (typeof this.props.tooltip === "string") {
            return (React.createElement(BootstrapNavItem, { ...relayProps, title: this.props.tooltip }, this.props.children));
        }
        else {
            const tooltip = (React.createElement(Popover, { id: this.props.id }, this.props.tooltip));
            return (React.createElement(OverlayTrigger, { overlay: tooltip, placement: this.props.placement || "bottom", delayShow: 300, delayHide: 150 },
                React.createElement(BootstrapNavItem, { ...relayProps }, this.props.children)));
        }
    }
}
/**
 * Icon with a tooltip
 *
 * @export
 * @class Icon
 */
export class Icon extends React.Component {
    render() {
        const relayProps = _.omit(this.props, ["tooltip", "placement"]);
        const classes = ["fake-link"].concat((this.props.className || "").split(" "));
        if (typeof this.props.tooltip === "string") {
            return (React.createElement("a", { className: classes.join(" "), title: this.props.tooltip },
                React.createElement(SvgIcon, { ...relayProps })));
        }
        else {
            const tooltip = (React.createElement(Popover, { id: this.props.id }, this.props.tooltip));
            return (React.createElement(OverlayTrigger, { overlay: tooltip, placement: this.props.placement || "bottom", delayShow: 300, delayHide: 150 },
                React.createElement("a", { className: classes.join(" ") },
                    React.createElement(SvgIcon, { ...relayProps }))));
        }
    }
}
export class ClickPopover extends React.Component {
    mRef;
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }
    render() {
        const { className, children, icon, id, tooltip } = this.props;
        const popover = (React.createElement(Popover, { id: `popover-${id}`, style: { maxWidth: 500 } }, children));
        return (React.createElement("div", { style: { display: "inline" } },
            React.createElement(IconButton, { id: `btn-${id}`, className: className, tooltip: tooltip, icon: icon, ref: this.setRef, onClick: this.toggleOverlay }),
            React.createElement(Overlay, { show: this.state.open, onHide: this.hideOverlay, placement: "left", rootClose: true, target: this.mRef }, popover)));
    }
    toggleOverlay = () => {
        this.setState(update(this.state, { open: { $set: !this.state.open } }));
    };
    hideOverlay = () => {
        this.setState(update(this.state, { open: { $set: false } }));
    };
    setRef = (ref) => {
        this.mRef = ref;
    };
}
